import { createSlice } from '@reduxjs/toolkit'

import type { RootState } from '..'
import { AUTH_STORAGE_KEY } from '../../utils/constants'
import {
  getItemLocal,
  removeItemLocal,
  setItemLocal,
} from '../../utils/storage'
import type { AccessTokenPayload, AuthTokens } from '../types/auth'

type AuthState = AuthTokens & {
  is_authenticated: boolean
  is_login_as?: boolean
}

const storedTokens: AuthTokens | null = getItemLocal(AUTH_STORAGE_KEY)

const initialState: AuthState = {
  is_authenticated: false,
  is_login_as: false,
  access_token: storedTokens ? storedTokens.access_token : null,
  refresh_token: storedTokens ? storedTokens.refresh_token : null,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setTokens: (state: AuthState, { payload }: { payload: AuthTokens }) => {
      const { access_token, refresh_token, is_login_as = false } = payload
      state.access_token = access_token
      state.refresh_token = refresh_token
      state.is_authenticated = true
      state.is_login_as = is_login_as
      setItemLocal(AUTH_STORAGE_KEY, payload)
    },
    setAccessToken: (
      state: AuthState,
      { payload }: { payload: AccessTokenPayload },
    ) => {
      state.access_token = payload.access_token
    },
    setAuthenticated: (
      state: AuthState,
      { payload: isAuthenticated }: { payload: boolean },
    ) => {
      state.is_authenticated = isAuthenticated
    },
    unsetTokens: (state: AuthState) => {
      state.access_token = null
      state.refresh_token = null
      state.is_authenticated = false
      removeItemLocal(AUTH_STORAGE_KEY)
    },
  },
})

export const { setTokens, setAccessToken, setAuthenticated, unsetTokens } =
  authSlice.actions

export const selectTokens = (state: RootState) => ({
  access_token: state.auth.access_token,
  refresh_token: state.auth.refresh_token,
})

export default authSlice.reducer
